import { Menubar, MenubarContent, MenubarItem, MenubarMenu, MenubarSeparator, MenubarShortcut, MenubarTrigger } from "@/shared/ui/menubar.tsx";
import MobileNavbar from "./MobileNavbar";
import { Button } from "@/shared/ui/button.tsx";
import { useLogout } from "@/features/auth-view/api";
import { CircleUser, Cog } from "lucide-react";
import { useContext } from "react";
import { AuthContext, AuthContextType } from "../context";
import { useAtomValue } from "jotai";
import { themeAtom } from "../atoms/theme-atoms";

const Navbar = () => {
  const { name } = useContext<AuthContextType>(AuthContext)

  const { logoutUser, status } = useLogout()

  const theme = useAtomValue(themeAtom)

  return (
    <nav className="fixed w-full top-0 left-0 bg-white/30 bg-clip-padding backdrop-filter backdrop-blur-xl bg-opacity-10 border-b border-b-gray-200 h-[5vh] px-3 flex items-center justify-between">
      <MobileNavbar />
      <img
        src={theme.logo}
        className="w-24" />
      <Menubar>
        <MenubarMenu>
          <MenubarTrigger asChild className="bg-transparent">
            <div className="flex items-center gap-1">
              <img src={theme.avatar} className="w-6 aspect-square rounded-full" />
              {name && <p className="font-poppins tracking-wide hidden sm:block text-sm">{name}</p>}
            </div>
          </MenubarTrigger>
          <MenubarContent>
            <MenubarItem>
              Account <MenubarShortcut><CircleUser color="black" size={14} /></MenubarShortcut>
            </MenubarItem>
            <MenubarItem>
              Settings <MenubarShortcut><Cog color="black" size={14} /></MenubarShortcut>
            </MenubarItem>
            <MenubarSeparator />
            <MenubarSeparator />
            <MenubarItem>
              <Button className="w-full h-7" onClick={() => logoutUser()} disabled={status === "pending"}>Logout</Button>
            </MenubarItem>
          </MenubarContent>
        </MenubarMenu>
      </Menubar>
    </nav>
  )
}

export default Navbar;
